import ApplicationController from './application_controller'

/* StimulusReflex controller for the ShipmentManager Reflex.
 *
 * The heavy lifting lives in app/reflexes/shipment_manager_reflex.rb. This
 * controller just wires the element up to StimulusReflex so the declarative
 * `data-reflex` triggers (add_vintage / remove_vintage) can morph the
 * `[shipment_vintages]` section of the shipment form.
 *
 * Learn more at: https://docs.stimulusreflex.com
 */
export default class extends ApplicationController {
  connect () {
    super.connect()
  }
}
